import _classCallCheck from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
/**
 * Virtual component for design
 */
import { genIdFn } from "@/utils/util";
var idFn = genIdFn();
var Component = /*#__PURE__*/function () {
  /**
   * 模拟生成组件ID
   * @returns {Timestamp} 简单使用时间戳模拟唯一ID
   */
  // 只保证同时生成不重复

  /**
   * 构造器
   * @param {String} id 组件唯一ID
   * @param {String} component_key 组件唯一KEY
   * @param {String} component_title 组件名字
   * @param {Number} template_id 模版ID
   * @param {Number} template_name 模版文件夹名称
   * @param {Number} template_title 模版中文名称
   * @param {Array} template_list 拥有的模版列表
   * @param {Object} remote_data 数据库存的值
   * @param {Object} remote_style 数据库存的值
   */
  function Component(_ref) {
    var _ref$id = _ref.id,
      id = _ref$id === void 0 ? 0 : _ref$id,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "U000001" : _ref$name,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "测试组件" : _ref$title,
      _ref$maxNum = _ref.maxNum,
      maxNum = _ref$maxNum === void 0 ? 1 : _ref$maxNum,
      draggable = _ref.draggable,
      _ref$location = _ref.location,
      location = _ref$location === void 0 ? 0 : _ref$location,
      _ref$componentValue = _ref.componentValue,
      componentValue = _ref$componentValue === void 0 ? {} : _ref$componentValue,
      _ref$componentPack = _ref.componentPack,
      componentPack = _ref$componentPack === void 0 ? {} : _ref$componentPack,
      _ref$platform = _ref.platform,
      platform = _ref$platform === void 0 ? "m" : _ref$platform,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type;
    _classCallCheck(this, Component);
    this.id = id || idFn();
    this.name = name;
    this.title = title;
    this.maxNum = maxNum;
    this.draggable = draggable;
    this.location = location;
    this.platform = platform;
    this.type = type;
    this.componentPack = Object.assign({}, componentPack);
    if (Object.keys(componentValue).length) {
      this.componentValue = Object.assign({}, componentValue);
    } else {
      this.componentValue = Object.assign({}, _.cloneDeep(componentPack.defaultValue) || {});
    }
  }

  /**
   * 复制自身
   * @returns {Vdc}
   */
  return _createClass(Component, [{
    key: "duplicate",
    value: function duplicate() {
      var vdc = new Component(this);
      vdc.id = idFn();
      return vdc;
    }
  }]);
}();
export { Component as default };